import React, { useState } from "react";

import mailicon from ".././assets/icons/mail.avif";
import { useIsMobile } from "./hooks/useIsMobile";
import client from "../api/client";
import { toast } from "react-toastify";
import CircularProgress from "./Generic/CircularProgress"; // eslint-disable-line no-unused-vars
import MainLayouts from "../layout/MainLayouts";
function VerifyEmail() {
  const [requestSent, setRequestSent] = useState(false);
  const [loading, setloading] = useState(false);




  const handleResendEmail = async () => {
    setloading(true);
    try {
      const token = localStorage.getItem("token");
      if (token) client.defaults.headers.Authorization = `Bearer ${token}`;
      const res = (await client.get(`/email/resend`)).data;
      if (res) {
        toast.success(
          "Email verification sent successfully please check your mail to verify your account"
        );
        setRequestSent(true);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("error resending email", error.response);
    }
    setloading(false);
  };
  // eslint-disable-next-line no-unused-vars
  const mobile = useIsMobile();
  return (
    <MainLayouts>
      <div className="bg-[#f4f6f9] min-h-screen pt-32 pb-24 flex items-center justify-center px-4">
        <div className="bg-white p-10 md:p-14 rounded-[20px] shadow-[0_10px_40px_rgba(0,0,0,0.06)] border border-gray-100 w-full max-w-[500px] flex flex-col items-center text-center relative overflow-hidden">
          {/* Subtle background decoration */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-primary rounded-full blur-[80px] opacity-10"></div>
          
          <img
            src={mailicon}
            alt="Mail verification"
            className="h-[180px] md:h-[220px] object-contain mb-8 z-10"
          />
          
          <h1 className="text-3xl md:text-4xl font-bold text-[#0b0f19] mb-4 z-10">
            Verify Email<span className="text-primary">.</span>
          </h1>
          
          <p className="text-gray-500 text-[15px] leading-relaxed mb-10 z-10">
            We've sent a verification link to your inbox. Please check your email and click the link to activate your account. If you don't see it, be sure to check your spam folder.
          </p>

          <button
            disabled={requestSent || loading}
            onClick={handleResendEmail}
            className={`w-full py-4 rounded-full flex items-center justify-center transition-all duration-300 font-bold uppercase tracking-wider text-[13px] z-10 shadow-sm ${
              requestSent 
                ? "bg-green-50 text-green-600 border border-green-200 cursor-not-allowed" 
                : loading
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-primary hover:bg-[#b0451e] text-white hover:shadow-md cursor-pointer border border-primary/20"
            }`}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
                Sending...
              </div>
            ) : requestSent ? (
              <div className="flex items-center gap-2">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                Verification Sent
              </div>
            ) : (
              "Resend Verification Link"
            )}
          </button>
        </div>
      </div>
    </MainLayouts>
  );
}

export default VerifyEmail;
